
<button class="btn-xs btn-danger" *ngIf="waitlistChat" (click)="removeFromWaitList()">Waitlist</button>
<button class="btn-xs btn-secondary" *ngIf="!waitlistChat" (click)="openDataUploadDialog()">Not in waitlist</button><span class="text fontS2 ml-2" *ngIf="waitlistChat">({{waitlistChat.get('description') }})</span>